import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

import type { UserInfo } from '../types'

interface AuthState {
  token: string | null
  user: UserInfo | null
  isAuthenticated: boolean
}

const loadUser = (): UserInfo | null => {
  const raw = localStorage.getItem('ufuqerp_user')
  return raw ? JSON.parse(raw) : null
}

const initial: AuthState = {
  token: localStorage.getItem('ufuqerp_token'),
  user: loadUser(),
  isAuthenticated: !!localStorage.getItem('ufuqerp_token'),
}

const slice = createSlice({
  name: 'auth',
  initialState: initial,
  reducers: {
    loginSuccess(
      state,
      a: PayloadAction<{ token: string; user: UserInfo; refreshToken?: string }>,
    ) {
      state.token = a.payload.token
      state.user = a.payload.user
      state.isAuthenticated = true
      localStorage.setItem('ufuqerp_token', a.payload.token)
      localStorage.setItem('ufuqerp_user', JSON.stringify(a.payload.user))
      if (a.payload.refreshToken)
        localStorage.setItem('ufuqerp_refresh_token', a.payload.refreshToken)
    },
    /** أدوار المستخدم أو صفحاته تغيّرت بالخادم — تُحدَّث الجلسة المفتوحة بلا خروج ودخول */
    userRefreshed(state, a: PayloadAction<UserInfo>) {
      if (!state.isAuthenticated) return
      state.user = a.payload
      localStorage.setItem('ufuqerp_user', JSON.stringify(a.payload))
    },
    logout(state) {
      state.token = null
      state.user = null
      state.isAuthenticated = false
      localStorage.removeItem('ufuqerp_token')
      localStorage.removeItem('ufuqerp_user')
      localStorage.removeItem('ufuqerp_refresh_token')
    },
  },
})

export const { loginSuccess, userRefreshed, logout } = slice.actions
export default slice.reducer
